import React from 'react';
import styled from 'styled-components';
import { openChat } from 'packages/smart-home-support/utils';
import { DynamicLink, DynamicLinkProps } from 'packages/smart-home-support/components';
import { usePartner, partnerValue } from 'packages/smart-home-support/partner';
import * as icons from './icons';
import { ProfilePageProps } from '../../models';
import { ExpertPortrait, Heading2, TabContent, Well, WellSubheading } from '../../styles';
import { PartnerContent } from 'packages/smart-home-support/partner';
import { getBreakpoint, getExpertSessionsUrl, getPhoneUrl } from '../../utils';
import { LinkId } from 'packages/smart-home-support/constants';

const breakpoint = getBreakpoint();

const s = {
  Heading2,
  WellSubheading,
  TabContent: styled(TabContent)`
    @media ${breakpoint} {
      display: flex;
      font-size: 20px;
    }
  `,
  Well: styled(Well)`
    margin-bottom: 0;
    @media ${breakpoint} {
      width: 50%;
    }
  `,
  ExpertPortrait: styled(ExpertPortrait)`
    margin-right: 14px;
  `,
  WellTop: styled.div`
    display: flex;
    align-items: center;
    @media ${breakpoint} {
      margin-bottom: 50px;
    }
  `,
  ActionGrid: styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    @media ${breakpoint} {
      width: 50%;
      margin-right: 80px;
      align-items: flex-start;
      align-content: flex-start;
    }
  `,
  Action: styled(DynamicLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 33%;
    margin-bottom: 25px;
    color: #000;
    text-decoration: none;
  `,
  ActionIcon: styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: #f6f6f6;
    width: 64px;
    height: 64px;
    border-radius: 9999px;
    padding: 20px;
    transition: background-color 0.2s;
    &:hover {
      background-color: #f1f1f1;
    }
    @media ${breakpoint} {
      width: 116px;
      height: 116px;
      padding: 36px;
    }
  `,
  ActionLabel: styled.span`
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    @media ${breakpoint} {
      font-size: 16px;
    }
  `,
  WellActionContainer: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 68px;
    box-sizing: border-box;
    border: 1px solid #d8dada;
    border-radius: 8px;
    background: #fff;
    margin: 16px 0;
    transition: border-color 0.2s, background-color 0.2s;
    &:hover {
      border-color: #a8aaaa;
    }
  `,
  WellAction: styled(DynamicLink)`
    padding: 15px 24px;
    font-size: 16px;
    text-align: left;
    text-decoration: none;
    color: #000;
    font-weight: bold;
  `,
};

type ActionProps = DynamicLinkProps & {
  icon: React.ComponentType;
  label: string;
};

const Action: React.FC<ActionProps> = (props) => {
  return (
    <s.Action id={props.id} onClick={props.onClick} to={props.to} target={props.target}>
      <s.ActionIcon>
        <props.icon />
      </s.ActionIcon>
      <s.ActionLabel>{props.label}</s.ActionLabel>
    </s.Action>
  );
};

const HomeTabOriginal: React.FC<ProfilePageProps> = () => {
  const [{ claimUrl }] = usePartner();

  return (
    <s.TabContent>
      <s.ActionGrid>
        <Action
          id={LinkId.DashboardHomeActionChat}
          label={partnerValue<string>({ Sprint: 'Live chat' }, 'Chat now')}
          icon={icons.Chat}
          onClick={openChat}
        />
        <Action id={LinkId.DashboardHomeActionCall} label="Call now" icon={icons.Call} to={getPhoneUrl()} />
        <Action
          id={LinkId.DashboardHomeActionClaim}
          label="Start a claim"
          icon={icons.Claim}
          to={claimUrl}
          target="_blank"
        />
        <Action
          id={LinkId.DashboardHomeActionWhatsCovered}
          label="What's covered?"
          icon={icons.WhatsCovered}
          to="/whats-covered"
        />
        <PartnerContent TechCoachHome={null}>
          <Action id={LinkId.DashboardHomeActionFaq} label="FAQ" icon={icons.FAQ} to="/faq" />
        </PartnerContent>
      </s.ActionGrid>
      <s.Well>
        <s.WellTop>
          <s.ExpertPortrait />
          <div>
            <s.Heading2>How can we help?</s.Heading2>
            <s.WellSubheading>
              <PartnerContent Sprint="Tech Experts have your back">Tech Coaches are here for you 24/7</PartnerContent>
            </s.WellSubheading>
          </div>
        </s.WellTop>
        <s.WellActionContainer>
          <s.WellAction id={LinkId.DashboardHomeSupportChat} onClick={openChat}>
            I have a tech question and could use some help.
          </s.WellAction>
        </s.WellActionContainer>
        <s.WellActionContainer>
          <s.WellAction id={LinkId.DashboardHomeSupportSupport} onClick={openChat}>
            One of my devices isn&rsquo;t working, and I need to get it fixed.
          </s.WellAction>
        </s.WellActionContainer>
        <PartnerContent TechCoachHome="" Asurion="">
          <s.WellActionContainer>
            <s.WellAction
              id={LinkId.DashboardHomeSupportExpertSessions}
              to={`${getExpertSessionsUrl()}?megaUseCase=securityprivacy`}
              target="_blank"
              showLeavingIcon
            >
              I want to schedule a 1:1 data privacy review.
            </s.WellAction>
          </s.WellActionContainer>
        </PartnerContent>
      </s.Well>
    </s.TabContent>
  );
};

export default HomeTabOriginal;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/HomeTabOriginal.tsx